import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngxs/store';
import { PuzzleFrameworkService } from '../puzzle-framework.service';
import { PuzzleGameState } from '../../store/puzzle-game.state';
import { PuzzleGameTypesEnum } from '../puzzle-game-types.enum';
import { PuzzleGameModel } from '../../store/puzzle-game.model';

@Component({
  selector: 'lib-app-abstract-puzzle-board',
  templateUrl: './puzzle-board.component.html',
  styleUrls: ['./puzzle-board.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class PuzzleBoardComponent {
  public puzzleGame: PuzzleGameModel;
  private puzzleGameType: PuzzleGameTypesEnum;
  private puzzleId: string;

  private solutionWord: string;
  private solutionOriginal: string;

  private jokerCount = 0;

  constructor(protected store: Store, protected framework: PuzzleFrameworkService) {}

  protected initPuzzleGame(
    puzzleID: string = this.puzzleId,
    GameType: PuzzleGameTypesEnum = this.puzzleGameType,
    jokerCount = 0,
    solutionWord?: string,
    solutionOriginal?: string
  ) {
    this.puzzleId = puzzleID;
    this.puzzleGameType = GameType;
    this.solutionWord = solutionWord;
    this.solutionOriginal = solutionOriginal;

    this.jokerCount = jokerCount;

    this.store.select(PuzzleGameState.getByID(puzzleID)).subscribe((puzzleGame) => {
      if (puzzleGame === null) {
        this.framework.initPuzzleGameState(puzzleID, GameType, jokerCount, solutionWord, solutionOriginal);
        return;
      }
      this.puzzleGame = puzzleGame as PuzzleGameModel;
    });
  }

  protected async resetPuzzleGame(
    puzzleID: string = this.puzzleId,
    GameType: PuzzleGameTypesEnum = this.puzzleGameType,
    jokerCount = this.jokerCount,
    solutionWord: string = this.solutionWord,
    solutionOriginal: string = this.solutionOriginal
  ) {
    return this.framework.initPuzzleGameState(puzzleID, GameType, jokerCount, solutionWord, solutionOriginal);
  }
}
